import React, { useEffect } from 'react';
import { GluteLab } from './pages/GluteLab';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <GluteLab data-id="element-0" data-mp="3k9b5s5c29u3b" />;
}